import { generatePath } from "react-router-dom";

import type { HasParams, ParamsFor, RequiredParamsFor } from "./types";

type HasRequired<P extends string> =
  RequiredParamsFor<P> extends never ? false : true;

export function makePath<P extends string>(
  pattern: P,
): HasParams<P> extends false
  ? () => string
  : HasRequired<P> extends true
    ? (params: ParamsFor<P>) => string
    : (params?: ParamsFor<P>) => string;

export function makePath(pattern: string) {
  return (params?: Record<string, string | number>) =>
    generatePath(pattern, params ?? {});
}
